// extracted by mini-css-extract-plugin
module.exports = {"generic-embed":"GenericEmbed_generic-embed__TW9Rw","embed-responsive":"GenericEmbed_embed-responsive__Ra6SD"};